import useRouter from 'hooks/useRouter';
import ChargeVehicleDetailView from '../../components/ChargeVehicleDetailView';

ChargeVehicleDetailScreen.propTypes = {};

function ChargeVehicleDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const vehicleId = router.query?.chargeVehicleId;

  return <ChargeVehicleDetailView vehicleId={vehicleId} />;
}

export default ChargeVehicleDetailScreen;
